/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

function FormImageProvider() {
  if (!this instanceof FormImageProvider) return new FormImageProvider();

  var that = this;

  this._storage = {};

  this.add = function (key, url) {
    that._storage[key] = url;
    return new Promise((resolve) => resolve());
  };

  this.get = function (key) {
    return new Promise((resolve, reject) => {
      var url = that._storage[key];
      if (!url) return reject();
      resolve(url);
    });
  };
}
